<template>
    <div class="text-left pb-8">
        <div class="flex justify-between items-center flex-wrap border-b mx-8 py-4">
            <div>
                <h1 class="text-2xl font-bold text-gray-800">Selected Students: {{ selectedStudents }}</h1>
            </div>
            <button
                class="bg-blue-600 text-white font-semibold px-4 py-2 rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-300"
                @click="viewStudents">
                View Students
            </button>
        </div>
        <!-- Job List -->
        <div class="mx-8 py-4">
            <h2 class="text-xl font-bold text-gray-800 mb-4">Available Jobs <span
                    v-if="!$apollo.queries.jobs.loading">({{ paginatorInfo.total }})</span></h2>
            <div class="flex flex-col" v-if="$apollo.queries.jobs.loading">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div v-for="(item, index) in first" :key="index"
                        class="bg-gray-100 p-4 rounded-lg shadow-sm hover:shadow-md flex flex-col">
                        <h3 class="text-lg font-semibold text-gray-500 bg-gray-500 animate-pulse h-6"></h3>
                        <p class="text-gray-500 bg-gray-500 animate-pulse h-5 mt-4"></p>
                        <p class="text-gray-500 bg-gray-500 animate-pulse h-2 mt-4"></p>
                        <p class="text-gray-500 bg-gray-500 animate-pulse h-2 mt-2"></p>
                        <p class="text-gray-500 bg-gray-500 animate-pulse h-2 mt-2"></p>
                        <div class="flex-auto flex flex-col justify-end mt-4">
                            <div class="flex flex-row flex-wrap">
                                <div class="w-1/2 pr-2">
                                    <button
                                        class="bg-blue-600 text-white font-semibold px-4 py-2 rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-300 w-full">
                                        Job Details
                                    </button>
                                </div>
                                <div class="w-1/2 pl-2">
                                    <button
                                        class="bg-green-600 text-white font-semibold px-4 py-2 rounded hover:bg-green-700 focus:ring-2 focus:ring-green-300 w-full">
                                        Send Email
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!$apollo.queries.jobs.loading && !hasItems" class="h-full flex justify-center items-center">
                <h1 class="text-center text-xl font-medium">No jobs found!</h1>
            </div>
            <div v-else class="flex flex-col">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div v-for="job in items" :key="job.id"
                        class="bg-gray-100 p-4 rounded-lg shadow-sm hover:shadow-md flex flex-col">
                        <h3 class="text-lg font-semibold text-gray-700">{{ job.job_title }} - {{ job.position_name }}
                        </h3>
                        <p class="text-gray-700 uppercase mb-4">{{ job.partner ? job.partner.en_company_name :
                            job.employer_name }}
                        </p>
                        <p class="text-gray-500 text-sm mb-4 truncate-3">{{ job.partner ? job.job_description :
                            job.employer_name }}
                        </p>
                        <div class="flex-auto flex flex-col justify-end">
                            <div class="flex flex-row flex-wrap">
                                <div class="w-1/2 pr-2">
                                    <button
                                        class="bg-blue-600 text-white font-semibold px-4 py-2 rounded hover:bg-blue-700 focus:ring-2 focus:ring-blue-300 w-full"
                                        @click="viewJobDetails(job.id)">
                                        Job Details
                                    </button>
                                </div>
                                <div class="w-1/2 pl-2">
                                    <button
                                        class="bg-green-600 text-white font-semibold px-4 py-2 rounded hover:bg-green-700 focus:ring-2 focus:ring-green-300 w-full"
                                        @click="assignToJob(job.id)">
                                        Send Email
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gql from "graphql-tag";
import Pagination from "../../components/shared/pagination.vue";
export default {
    name: 'send-job-opportunity-email',
    components: {
        Pagination,
    },
    props: ["filters", "selectedStudents"],
    data() {
        return {
            jobs: [],
            page: 1,
        };
    },
    computed: {
        first() {
            if (window.innerWidth > 1023) {
                return 9;
            } else {
                return 10;
            }
        },
        items() {
            return this.jobs.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.jobs.paginatorInfo;
        },
        localOrNonLocal() {
            if (this.filters.local_or_non_local == 'Local') {
                return 'Local';
            } else if (this.filters.local_or_non_local == 'Non Local') {
                return 'Non Local';
            } else {
                return 'Both Local and Non Local';
            }
        },
    },
    apollo: {
        jobs() {
            return {
                query: gql`
          query GetAllJobs(
            $first: Int!
            $page: Int!
            $filter_by_employer_type: String
            $filter_by_partner: Int
            $entity: String
            $job_for: String
            $entity_industry: String
            $local_or_non_local: String
          ) {
            jobs(
              first: $first
              page: $page
              filter_by_employer_type: $filter_by_employer_type
              filter_by_partner: $filter_by_partner
              entity: $entity
              job_for: $job_for
              entity_industry: $entity_industry
              local_or_non_local: $local_or_non_local
            ) {
              error
              error_code
              message
              data {
                id
                employer_type
                partner_id
                employer_name
                token
                grade_number
                job_title
                position_name
                position_number
                job_description
                minimum_qualification
                preferred_qualification
                expected_skills
                special_instructions
                division
                department
                job_start_date
                job_close_date
                job_category
                salary
                vacancy
                request_count
                approved_count
                rejected_count
                benefits
                job_location
                working_hours
                contract_type
                job_for
                gender
                entity
                created_by_user_id
                partner {
                  id
                  en_company_name
                  ar_company_name
                  company_logo
                }
              }
              paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
              }
            }
          }
        `,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        filter_by_employer_type: "",
                        filter_by_partner: null,
                        entity: this.filters.entity,
                        job_for: "",
                        entity_industry: "",
                        local_or_non_local: this.localOrNonLocal
                    };
                },
                fetchPolicy: "cache-and-network",
            };
        },
        entities() {
            return {
                query: gql`
          query GetEntityList {
            entities {
              data {
                entity
              }
            }
          }
        `,
                fetchPolicy: "cache-and-network",
            };
        },
    },
    methods: {
        setPage(page) {
            this.page = page;
        },
        viewStudents() {
            alert("Display students list");
        },
        viewJobDetails(jobId) {
            alert(`viewJobDetails: ${jobId}`);
        },
        assignToJob(jobId) {
            alert(`Assigning students to job ID: ${jobId}`);
        },
    },
}
</script>

<style lang="scss" scoped>
.truncate-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>